<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-07-08 16:08:43
 * @LastEditors: Yang Zhang
 * @LastEditTime: 2022-01-07 16:26:11
-->
<template>
  <a-layout>
    <PageHeader :list="routeList" back-url="/license-center" />
    <a-layout-content class="page-main">
      <router-view v-slot="{ Component }">
        <transition name="fade-slide" mode="out-in" appear>
          <component :is="Component" />
        </transition>
      </router-view>
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { PageHeader } from '@/components'
import routeList from '@/router/routes'

export default defineComponent({
  components: {
    PageHeader
  },
  data() {
    return {
      routeList
    }
  }
})
</script>

<style lang="less">
.ai-point-layout {
  height: 100vh;

  .el-header {
    padding: 0;
  }

  .el-main {
    width: 100%;
    background: #ebedf0;
    padding: 0;
  }
}
</style>
